/**
 * Product description Read more / Read less
 */
(function () {
  'use strict';

  var TRANSITION_MS = 350;

  function getCollapsedHeight(wrapper) {
    return parseInt(wrapper.getAttribute('data-collapsed-height') || '240', 10);
  }

  function isVisible(wrapper) {
    if (!wrapper) return false;
    if (wrapper.offsetParent !== null) return true;
    return !!wrapper.closest('.active, .product_tab_panel.active');
  }

  function setCollapsed(wrapper, content, toggle) {
    var collapsedHeight = getCollapsedHeight(wrapper);
    var readMoreSpan = toggle.querySelector('[data-label-more]');
    var readLessSpan = toggle.querySelector('[data-label-less]');

    content.classList.add('is-collapsed');
    content.classList.remove('is-expanded');
    content.style.maxHeight = collapsedHeight + 'px';
    if (readMoreSpan) readMoreSpan.hidden = false;
    if (readLessSpan) readLessSpan.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  function setExpanded(wrapper, content, toggle) {
    var readMoreSpan = toggle.querySelector('[data-label-more]');
    var readLessSpan = toggle.querySelector('[data-label-less]');

    content.classList.add('is-expanded');
    content.classList.remove('is-collapsed');
    content.style.maxHeight = content.scrollHeight + 'px';
    if (readMoreSpan) readMoreSpan.hidden = true;
    if (readLessSpan) readLessSpan.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');

    window.setTimeout(function () {
      if (content.classList.contains('is-expanded')) {
        content.style.maxHeight = 'none';
      }
    }, TRANSITION_MS);
  }

  function measureWrapper(wrapper, force) {
    if (!wrapper) return;
    if (wrapper.dataset.readMoreReady === 'true' && !force) return;
    if (force) {
      wrapper.removeAttribute('data-read-more-ready');
    }

    var content = wrapper.querySelector('[data-read-more-content]');
    var toggle = wrapper.querySelector('[data-read-more-toggle]');
    if (!content || !toggle) return;

    if (!isVisible(wrapper)) {
      wrapper.dataset.readMorePending = 'true';
      return;
    }

    wrapper.removeAttribute('data-read-more-pending');
    var collapsedHeight = getCollapsedHeight(wrapper);

    content.classList.remove('is-expanded');
    content.classList.add('is-collapsed');
    content.style.maxHeight = collapsedHeight + 'px';
    toggle.hidden = true;

    window.requestAnimationFrame(function () {
      if (content.scrollHeight <= collapsedHeight + 16) {
        content.classList.remove('is-collapsed', 'is-expanded');
        content.style.maxHeight = '';
        toggle.hidden = true;
        wrapper.dataset.readMoreReady = 'true';
        return;
      }

      toggle.hidden = false;
      wrapper.dataset.readMoreReady = 'true';
    });

    if (wrapper.dataset.readMoreBound !== 'true') {
      wrapper.dataset.readMoreBound = 'true';
      toggle.addEventListener('click', function () {
        if (content.classList.contains('is-expanded')) {
          setCollapsed(wrapper, content, toggle);
        } else {
          setExpanded(wrapper, content, toggle);
        }
      });
    }
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-product-description-read-more]').forEach(function (wrapper) {
      measureWrapper(wrapper, false);
    });
  }

  function refreshPending(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-read-more-pending="true"]').forEach(function (wrapper) {
      measureWrapper(wrapper, true);
    });
  }

  window.KraftProductDescriptionReadMore = {
    init: initAll,
    refresh: refreshPending
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    refreshPending(event.target);
  });
})();
